import { Filmomtale } from '@filmweb/sanity-types';
import OneCultureShowWithoutTime from "components/frontpage/culture/OneCultureShowWithoutTime";
import MoviePoster from 'components/movieposter/MoviePoster';
import { ICultureArticle } from "lib/types/sanity";
import styles from "./RelatedMovies.module.css";





//#endregion

//#region [Props]
type RelatedMoviesProps = {
    movies?: Filmomtale[];
    localMovies?: ICultureArticle[]
};
//#endregion

//#region [Component]
export default function RelatedMovies({ movies, localMovies }: RelatedMoviesProps) {
    if ((movies?.length ?? 0) === 0 && (localMovies?.length ?? 0) === 0) {
        return null;
    }
    return (<div>
        {(localMovies?.length ?? 0) > 0 && <div className={styles.SCultureGrid}>
            {localMovies!.map(kul => <OneCultureShowWithoutTime key={kul.kulnr.current} article={kul} />)}
        </div>}
        {(movies?.length ?? 0) > 0 && <div className={styles.SMovieGrid} >
            {movies?.map((movie) => {
                return (<article className={styles.SMovie} key={movie.mainVersionEDI}><MoviePoster edi={movie.mainVersionEDI} filmomtale={movie} sizes="(min-width: 800px) 145px, 116px" /></article>)
            })}
        </div>}
    </div>);
}
//#endregion